export enum CASINO_TICKET_TYPE {
  SLOTS = 'slots',
}

export enum CASINO_TICKET_RESULT {
  WON = 'won',
}

export enum CASINO_CATEGORY_IDS {
  FEATURED = 0,
  SLOTS = 1,
  LIVE_CASINO = 2,
  TABLE_GAMES = 3,
  VIRTUAL_SPORTS = 4,
}

export enum CASINO_CATEGORY_NAMES {
  FEATURED = 'Featured',
  SLOTS = 'Slots',
  LIVE_CASINO = 'Live Casino',
  TABLE_GAMES = 'Table Games',
  VIRTUAL_SPORTS = 'Virtual Sports',
}

export enum CASINO_CATEGORY_PATH_NAMES {
  FEATURED = 'featured',
  SLOTS = 'slots',
  LIVE_CASINO = 'live-casino',
  TABLE_GAMES = 'table-games',
  VIRTUAL_SPORTS = 'virtual-sports',
}

export enum GAME_REACHED_FROM {
  SPORTSBOOK_FEATURED = 'Sportsbook Featured',
  INSTANT_GAMES = 'Instant Games',
  SEARCH = 'Search',
}

export enum CASINO_TAG_ID {
  POPULAR = 1,
  NEW = 2,
  NETWORK_PROMOTION = 3,
  EXCLUSIVE = 4,
  TOURNAMENT = 5,
  CASH_DROP = 6,
  FREE_SPINS = 7,
}

export enum CASINO_PROVIDER_GAME_PAY_ID {
  MEGA = '0',
}

export enum CASINO_TAG_NAME {
  POPULAR = 'Popular',
  NEW = 'New',
  NETWORK_PROMOTION = 'Network Promotion',
  EXCLUSIVE = 'Exclusive',
  TOURNAMENT = 'Tournament',
  CASH_DROP = 'Cash Drop',
  FREE_SPINS = 'Free Spins',
}
